import { render, staticRenderFns } from "./Videoconsultas.vue?vue&type=template&id=37b56800"
import script from "./Videoconsultas.vue?vue&type=script&lang=js"
export * from "./Videoconsultas.vue?vue&type=script&lang=js"
import style0 from "./Videoconsultas.vue?vue&type=style&index=0&id=37b56800&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports